import { Text, useBreakpointValue } from '@chakra-ui/react';

export const ViewSectionPracticeAreas = (props) => {
  const { profile } = props;

  const titleTxtStyle = useBreakpointValue({ base: 'h3mobile', md: 'h3' });

  // Render
  return (
    <div className='flex flex-col gap-5 p-[30px]'>
      <Text textStyle={titleTxtStyle}>Areas of expertise</Text>
      <div className='flex flex-wrap gap-4'>
        {profile.practiceAreas?.map((area) => (
          <p key={area.value} className='text-sm rounded-full font-bold bg-brand-off text-brand-alt px-4 py-2'>
            {area.label}
          </p>
        ))}
      </div>
    </div>
  );
};
